"use client";

import type { ProductBrowseResult } from "@/dao/product";
import { cn } from "@/lib/utils";
import { AddToCartButton } from "../AddToCartButton";

export const InlineAddToCart = ({
	variant,
	product,
	domain,
}: {
	variant: ProductBrowseResult["data"][number]["variants"][number];
	product: ProductBrowseResult["data"][number];
	domain: string;
}) => {
	return (
		<div
			onClickCapture={(e) => {
				e.preventDefault();
			}}
			className={cn(
				"rounded-b-lg p-2 backdrop-blur-sm bg-neutral-500/10 flex justify-center items-center",
				"absolute bottom-0 left-0 right-0 z-10",
				"transition-[opacity_transform] duration-300 opacity-0 translate-y-full",
				"group-hover:opacity-100 group-hover:translate-y-0 overflow-hidden",
			)}
		>
			{/* <Button
                variant="link"
                size="icon"
                className="h-8 w-8 rounded-lg shadow-lg border border-neutral-400 bg-neutral-200 text-neutral-500"
              >
                <ShoppingBagIcon className="h-4 w-4" />
                <span className="sr-only">Add to cart</span>
              </Button> */}
			<AddToCartButton
				variant={variant}
				subscription={null}
				product={product}
				domain={domain}
				style={{}}
				className={cn(
					"text-sm text-neutral-800 bg-neutral-50 hover:bg-neutral-100 shadow-none [&+#add-to-cart-msg]:hidden",
				)}
			/>
		</div>
	);
};
